__turbopack_context__.v({
  "imgCont": "_8XyfSq_imgCont",
  "imgCont2": "_8XyfSq_imgCont2",
  "imgContainer": "_8XyfSq_imgContainer",
  "root": "_8XyfSq_root",
  "sticky": "_8XyfSq_sticky",
  "textContent1": "_8XyfSq_textContent1",
});
